import * as React from 'react';
import { CTA } from './CTA';
import { Link } from './Link';
import { __ } from '../helpers/TranslationService';
import loadable from '@loadable/component';

const Gallery = loadable(() => import('./Gallery/Gallery'));

export interface ISliderProps {
    images: string[];
}

export const GallerySlider = ({ images }: ISliderProps) => {
    return (
        <div className="gallerySlider">
            <Gallery images={images} />
        </div>
    );
};

export interface IProps {
    headline: string;
    offerUrl: string;
    content: string;
    galleryImages: string[];
}

export const GallerySliderSection = (props: IProps) => {
    return (
        <div className="onlyDesktop gallerySliderSection row" id="overview">
            <GallerySlider images={props.galleryImages} />
            <div className="gallerySliderSectionContent">
                <span dangerouslySetInnerHTML={{ __html: props.headline }} />
                <div dangerouslySetInnerHTML={{ __html: props.content }} />
                <CTA wrapperStyle={{ width: '345px', marginTop: '40px', padding: '11px 5px' }}>
                    <Link href={props.offerUrl} mask={true}>
                        {__('show all offers', 'dreamlines')}
                    </Link>
                </CTA>
            </div>
        </div>
    );
};
